import script from "./specificationspopup.vue?vue&type=script&setup=true&lang=js"
export * from "./specificationspopup.vue?vue&type=script&setup=true&lang=js"

import "./specificationspopup.vue?vue&type=style&index=0&id=90d77ffe&lang=scss"
import "./specificationspopup.vue?vue&type=style&index=1&id=90d77ffe&lang=scss&scoped=scoped"

import exportComponent from "D:\\工作项目\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90d77ffe"]])

export default __exports__